<script setup lang="ts">
import Modal from "@/components/Reusables/Modal/Modal.vue";

const emits = defineEmits(["toggleModal"]);

const toggleModal = () => {
  emits("toggleModal");
};
</script>

<template>
  <Modal
    heading="Reference Area"
    size="w-3/6 h-fit"
    @toggle-modal="toggleModal">
    <div class="flex flex-col gap-4 p-4">
      <ul class="t-small flex list-disc flex-col gap-4">
        <li>
          All basement areas, ground-level waste rooms, and security rooms are included. This means that these areas are fully
          counted (100 percent). However, this only applies to rooms that are integrated into the building. Detached security
          rooms and waste rooms are not included in terms of materials or areas.
        </li>
        <li>
          External ramps, stairs, fire escapes, balconies, balcony corridors, and similar structures are included at 25 percent.
          This means that in cases where these areas are not included in the area calculation according to §455, they should be
          included at 25 percent of the area in the calculation of climate impact. Other examples of areas that may be subject to
          this rule could be stack-parking areas, which allow for parking at multiple levels within a single floor.
        </li>
        <li>
          Integrated garages for single-family houses, townhouses, and similar structures are only included at 50 percent.
          Integrated garages mean that the garage is part of and constructed together with the building, sharing exterior walls,
          roof, etc.
        </li>
        <li>
          Integrated carports, outbuildings, canopies, sheds, and similar structures are only included at 25 percent. This covers
          constructions that are built as an integrated part of the building. For example, in a building constructed on pillars
          where the area under the pillars is used for parking spaces, 25 percent of the area under the pillars should be included
          in the reference area.
        </li>
        <li>
          Walk-on ceilings and similar structures are only included at 25 percent. Walk-on ceilings include, for example, utility
          ceilings that have a height equal to the room height and can support the weight of people.
        </li>
      </ul>
      <span>
        Source:
        <a
          href="https://www.retsinformation.dk/eli/lta/2022/1464"
          class="text-app-blue-600 hover:text-app-blue-700"
          >www.retsinformation.dk</a
        >
      </span>
    </div>
  </Modal>
</template>
